/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from 'react';
import {Modal, ModalTitle, TitleSection, DownloadMoment} from 'trux';
import './DownloadMomentModal.css';

export const DownloadMomentModal = (props) => {

  return (
    <Modal open={props.downloadMomentModalOpen} onShadeClick={() => {props.setDownloadMomentModalOpen(false)}} className="download-moment-modal">
      <TitleSection onCloseClick={() => {props.setDownloadMomentModalOpen(false)}}>
        <ModalTitle content='Download'/>
      </TitleSection>
      { props.downloadMomentModalOpen && (
        <DownloadMoment onClose={() => props.setDownloadMomentModalOpen(false)} item={props.item}/>
      )}
    </Modal>
  )
}
